import Vue from 'vue';

export default {
	get(id, lang, usePublicUrl = false) {
		return new Promise((resolve, reject) => {
			const url = usePublicUrl ?
				process.env.GET_OBJECTSETUP_PUBLIC_URL :
				process.env.GET_OBJECTSETUP_URL;

			Vue.http.post(url, { PKM_Objekt: id, sprache: lang })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	set(id, data) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.SAVE_OBJECTSETUP_URL,
			              { PKM_Objekt: id, ...data })
			.then((response) => {
				resolve(response);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	batchSet(datasets) {
		const promisifiedSiteRequests =
			datasets.map(dataset => (this.set(dataset.id, dataset.data)));
		return Promise.all(promisifiedSiteRequests);
	},

	statusSet(id, status, lang, additionalParams) {
		return new Promise((resolve, reject) => {
			const requestBody = {
				PKM_Objekt: id,
				FKM_Status: status,
				...additionalParams,
			};

			if (lang) {
				requestBody.pid_sprache = lang;
			}

			Vue.http.post(process.env.CHANGE_STATUS_URL, requestBody)
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	pkStatusSet(id, status) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CHANGE_PROCESS_COMMUNICATION, {
				PKM_Objekt: id,
				PKM_Status: status,
			})
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	batchStatusSet(datasets) {
		const promisifiedStatusSetRequests =
			datasets.map(dataset => (this.statusSet(dataset.PKM_Objekt, dataset.FKM_Status)));
		return Promise.all(promisifiedStatusSetRequests);
	},

	setProjectToCountry(objId, countryId) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.SET_PROJECT_TO_COUNTRY, {
				PKM_Objekt: objId,
				FKM_Land: countryId,
				modus: 'update',
			})
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	clearLightscoutCacheEntry(id) {
		const url = `${process.env.LS2014_SERVER}/struktur/php/tapete.php?aktion=clear&oid=${id}`;
		return fetch(url).then(response => response.text());
	},

	getIdTextRTFExport(objID, lang) {
		const placeholderValues = {
			object_id: objID,
			language: lang,
		};

		const url = process.env.RTF_EXPORT_ID_TEXT_URL.replace(/\{\{\s*(.*?)\s*\}\}/g, (_, placeholderKey) => {
			if (placeholderKey in placeholderValues) {
				return placeholderValues[placeholderKey];
			}

			return '';
		});

		return Vue.http.get(url)
			.then(response => response.text());
	},
};



// WEBPACK FOOTER //
// ./src/api/objectsetup.js